import * as React from 'react';

/**
 * This component marks PII.
 * The fs-exclude class is for FullStory to mask PII when user recordings are played.
 */
export const PersonallyIdentifiableInfo: React.FC<{ component?: 'div' | 'span'; skeletonWidth?: number | string }> = ({
  component: Component = 'span',
  children,
}) => {
  return <Component className="fs-exclude">{children}</Component>;
};
